export const environment = {
  production: true,
  buildId: '3686741283423171',
  configFile: 'config.json',
};
